import React, { Fragment } from "react";
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../../../../../styles/diario.scss';
import Moment from 'moment';

const Obra = (props) => {

    const dataInicio = Moment(props.obr.dataInicio).utc(false).format("DD [de] MMMM [de] YYYY")

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchObras()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Header><h5>{props.obr.nome} em {props.obr.local}</h5></Card.Header>
                    <Card.Body>
                        <p>Data de início: {dataInicio}</p>
                        <p>Etapa atual: {props.obr.etapa}</p>
                        <p>Valor: {props.obr.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })}</p>
                        <p>Empresa responsável: {props.obr.empresa}</p>
                        <p>Percentual concluído: {props.obr.percentualConcluido}</p>
                        <p>Situação atual: {props.obr.situacao}</p>
                        <p>Previsão de conclusão: {props.obr.previsaoConclusao}</p>
                        {props.obr.situacao === "Paralizada" ?
                            <Fragment>
                                <p>Motivo da paralização: {props.obr.motivoParalizacao}</p>
                                <p>Responsável pela paralização: {props.obr.responsavelParalizacao}</p>
                                <p>Previsão de Retomada das Obras: {props.obr.previsaoReinicio}</p>
                            </Fragment>
                            : null}
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.obr._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.obr._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Obra;